<cbic-page-ribbon></cbic-page-ribbon>
<cbic-loader></cbic-loader>
<div>


  <router-outlet name="navbar"></router-outlet>

    <!-- Speaker toggle button at top right -->
<span style="position: fixed; top: 50px; right: 30px; z-index: 9999;">
  <button class="fw-medium" (click)="toggleReadAloud()" [attr.aria-pressed]="readAloudEnabled" [ngClass]="{ 'active': readAloudEnabled }" style="padding: 0px 5px;
    font-size: 16px;
    border-radius: 24px;
    border: none;
    background: #eeeeeeeb;
    color: #213185;
    cursor: pointer;
    box-shadow: 0 2px 8px #0002;">
    {{ readAloudEnabled ? '🔊 Screen Reader: ON' : '🔇 Screen Reader: OFF' }}
  </button>
</span>

</div>
<div class="container noPadding" style="max-width:2600px;" (mouseover)="onDynamicTextHover($event)">
<div id="dynamicContent" class="container-fluid">
  <!---mobile menu start here-->

  <nav class="navbar  hemberger-section">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <div class="bar1"></div>
      <div class="bar2"></div>
      <div class="bar3"></div>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav  me-auto mb-2 mb-lg-0">
        <li *ngFor="let menuItem of menuList"
         [attr.class]="selectedMenu?.id == menuItem.id? 'active': ''">
          <a href="" (click)="updateSelectedMenu(menuItem)"> <img src='content/images/left_navigation_icons/{{menuItem.menuIcon}}' alt="nav icon" class="img-fluid" width="45"></a>
          <a (click)="updateSelectedMenu(menuItem)" routerLink="/{{menuItem.path}}" cbicTranslate="menu.{{menuItem.menuName}}"></a>
        </li>
      </ul>
    </div>

  </nav> <!---mobile menu ends here-->

  <div class="container-fluid noPadding">
 
<div class="row">
 

  <div class="col-xl-3 col-md-3 col-xxl-3 main-menu"
  *ngIf="pathname!=='/entities/view-sticker'">
  <!--Left Menu with Conent-->
  <nav class="d-sm-none d-md-block d-lg-block d-none d-none-medium-device">
    <ul>
      <li *ngFor="let menuItem of menuList"
        [attr.class]="selectedMenu?.id == menuItem.id? 'active': ''">
        <a (click)="updateSelectedMenu(menuItem)" routerLink="/{{menuItem.path}}"> <img src='content/images/left_navigation_icons/{{menuItem.menuIcon}}' alt="nav icon" class="img-fluid" width="45" height="30"></a>
        <a (click)="updateSelectedMenu(menuItem)" routerLink="/{{menuItem.path}}" cbicTranslate="menu.{{menuItem.menuName}}" title="{{menuItem.menuName}}" class="title-text"></a>
      </li>
    </ul>
  </nav>
</div>

<div class=" col-xl-12 col-xxl-12" *ngIf="pathname=='/entities/view-sticker'">
  <router-outlet></router-outlet>
</div>

<div class="col-xxl-9 col-xl-9 col-md-12 col-sm-12 main-container relative"  *ngIf="pathname!=='/entities/view-sticker'">
  <div class="container-fluid noPadding">
    <div class="row noMargin">
      <div class="col-12">
        <div class="dynamic-content-container">    
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
     


   
 
 

</div>


</div>

  </div>
  

  <cbic-footer *ngIf="pathname!=='/entities/view-sticker'  && menuList.length > 0 "></cbic-footer>
 
</div></div>


